import { delayPromise } from '@nextiva/engagement-ui';
import { merge, property } from 'lodash';
import axios from 'axios';

import { paginationLimit } from 'config/templateList/Pagination';

import { TEMPLATE_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';
import {
  buildApiV2Url,
  jsonApiHeaders,
  toIsOnlyFavoriteFilter,
  toTemplateListSearchFilter,
  toSurveyListSortDirection,
  toIsOnlyPlatformFilter,
  toIsOnlyMyFilter,
} from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import TemplateListJsonApiFields from './config/TemplateListJsonApiFields';
import mapTemplateListDataFromApi from './dataMapper/mapTemplateListDataFromApi';

export default ({
  sortOrder,
  sortBy,
  pageNumber = 0,
  search = '',
  onlyFavorites = false,
  onlyPlatform,
  onlyMy,
} = {}) => {
  const offset = pageNumber * paginationLimit;
  const params = merge({}, TemplateListJsonApiFields, {
    sort: toSurveyListSortDirection(sortOrder, sortBy),
    page: {
      limit: paginationLimit,
      offset,
    },
    filter: {
      ...toTemplateListSearchFilter(search),
      ...toIsOnlyPlatformFilter(onlyPlatform),
      ...toIsOnlyMyFilter(onlyMy),
    },
    ...toIsOnlyFavoriteFilter(onlyFavorites),
  });

  return delayPromise(
    axios
      .get(buildApiV2Url(TEMPLATE_TYPE_COLLECTION_PATH, params), {
        headers: jsonApiHeaders,
      })
      .catch(generateApiError())
      .then(property('data'))
      .then(mapTemplateListDataFromApi),
  );
};
